export default __webpack_public_path__ + "static/afterall-serif-regular-woff2-c30d5776d28ee10b5dca069b5c53b952.woff2";